import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
// import Select from 'react-select';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { Alert, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Select, { components } from 'react-select';
import { toast } from 'react-toastify';
import { KTSVG } from '../../../_metronic/helpers';
import CurrencyComp from '../../../components/currencyComponent/CurrencyComp';
import DateComp from '../../../components/dateComponent/DateComp';
import DateRangeComp from '../../../components/dateComponent/DateRangeComp';
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent';
import NoRecordFound from '../../../components/noRecord/NoRecordFound';
import Pagination from '../../../components/pagination/Pagination';
import RefreshComponent from '../../../components/refreshComponent/RefreshComponent';
import SearchBarComponent from '../../../components/searchBar/SearchBarComponent';
import TableHeading from '../../../components/tableHeading/TableHeading';
import TableSettingMenu from '../../../components/tableHeading/TableSettingMenu';
import SearchSelect from '../../../components/textFields/SearchSelect';
import TextField from '../../../components/textFields/TextField';
import { constraintConfig } from '../../../constraintConfig';
import { selectAuth } from '../../../features/authSlice';
import { useAppSelector } from '../../../hooks';
import { useLazyGetExpenseItemByExpenseIdQuery } from '../../../services/ExpenseApi';
import { useGetAllDepartmentByManagerQuery, useGetAllExpenseTypeQuery, useGetAllManagersLookupQuery, useGetAllUsersLocationQuery, useGetReportExpenseStatusQuery, useGetReportUsersByManagerIdQuery, useGetUsersByManagerIdQuery } from '../../../services/GeneralApi';
import { useGetExpensesReportByUserV2Query } from '../../../services/ReportAndAnalyticsApi';
import useColumnVisibility from '../../customHooks/useColumnVisibility';
import labelKey from "../../localization/label.json";
import tosterKey from "../../localization/toster.json";
import ExpenseDetailModal from '../expenseItems/ExpenseDetailModal';
import ExpenseStatusComp from '../../../components/StatusComp/ExpenseStatusComp';
import DownloadReport from './DownloadReport';
import { myReportPaths, queryReportPaths, teamReportPaths } from './ReportPaths';

const { Option } = components;
type Option = {
    value: string;
    label: string;
};

// Custom Option component to add checkboxes
const CheckboxOption = (props: any) => {
    return (
        <Option {...props} className='d-flex align-items-start gap-2'>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
            />{" "}
            <label>{props.label}</label>
        </Option>
    );
};

const ExpenseDetail = () => {
    const currentDate = moment().format('MM/DD/YYYY');
    const sevenDaysAgo = moment().subtract(6, 'days').format('MM/DD/YYYY');
    const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'expenseDetail' });
    const location = useLocation()
    const { userAccountID, roleID, reportPermision } = useAppSelector(selectAuth);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [searchStr, setSearchStr] = useState(''); // debounce search
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [sortBy, setSortBy] = useState("createdDate");
    const [sortOrder, setSortOrder] = useState("desc");
    // const [filterByMonth, setfilterByMonth] = useState("");
    const [filterByStartDate, setFilterByStartDate] = useState(sevenDaysAgo);
    const [filterByEndDate, setFilterByEndDate] = useState(currentDate);
    const [filterByStatus, setFilterByStatus] = useState("0");
    const [filterByExpType, setFilterByExpType] = useState("0");
    const [sortedColumn, setSortedColumn] = useState("createdDate");
    const [filterByDeptId, setFilterByDeptId] = useState<string[]>([]);
    const [filterByLocationIds, setFilterByLocationIds] = useState<string[]>([]);
    const [filterByUserIds, setFilterByUserIds] = useState<string[]>([]);
    const [filterByManager, setFilterByManager] = useState(0);
    const [filterByTimePeriod, setFilterByTimePeriod] = useState('');


    const [selectedDeptId, setSelectedDeptId] = useState<Option[]>([]);
    const [selectedLocationIds, setSelectedLocationIds] = useState<Option[]>([]);
    const [selectedUserIds, setSelectedUserIds] = useState<Option[]>([]);

    const [localFilterByStartDate, setLocalFilterByStartDate] = useState(sevenDaysAgo);
    const [localFilterByEndDate, setLocalFilterByEndDate] = useState(currentDate);
    const [localFilterByStatus, setLocalFilterByStatus] = useState("0");
    const [localFilterByExpType, setLocalFilterByExpType] = useState("0");
    const [localFilterByDeptId, setLocalFilterByDeptId] = useState<string[]>([]);
    const [localFilterByLocationIds, setLocalFilterByLocationIds] = useState<string[]>([]);
    const [localFilterByUserIds, setLocalFilterByUserIds] = useState<string[]>([]);
    const [localFilterByTimePeriod, setLocalFilterByTimePeriod] = useState("");
    const [isApplyingFilters, setIsApplyingFilters] = useState(false);


    const myReportPath = myReportPaths.includes(location.pathname);
    const queryFeportPath = queryReportPaths.includes(location.pathname);
    const teamFeportPath = teamReportPaths.includes(location.pathname);

    const { data: ExpenseStatusLookup } = useGetReportExpenseStatusQuery('')
    const { data: getAllExpenseType } = useGetAllExpenseTypeQuery('')
    const { data: getAllDepByManager, refetch: getAllDepByManagerRefetch } = useGetAllDepartmentByManagerQuery({ reportPermission: queryFeportPath ? reportPermision : false })
    const { data: getAllUsersLocation, refetch: getAllUsersLocationRefetch } = useGetAllUsersLocationQuery({ reportPermission: queryFeportPath ? reportPermision : false })
    const { data: getAllManagers } = useGetAllManagersLookupQuery('')
    const { data: getUserByManager, refetch: userByManagerRefetch } = useGetReportUsersByManagerIdQuery({ managerId: filterByManager })
    const [expenseItemByIdTrigger, { data: expenseItemData, isFetching }] = useLazyGetExpenseItemByExpenseIdQuery({})
    const [localFilterByHideFromManager, setLocalFilterByHideFromManager] = useState("0");



    useEffect(() => {
        if (filterByManager) {
            userByManagerRefetch()
        }
        userByManagerRefetch()
        getAllDepByManagerRefetch()
        getAllUsersLocationRefetch()
    }, [filterByManager])

    const { data, isFetching: isLoading, refetch, isSuccess } = useGetExpensesReportByUserV2Query({
        reportFilter: myReportPath ? 0 : queryFeportPath ? 2 : 1,
        userAccountId: userAccountID,
        pageNumber: page,
        pageSize: pageSize,
        sortBy: sortBy,
        sortOrder: sortOrder,
        searchStr: searchStr,
        filterByExpType: filterByExpType,
        startDate: filterByStartDate,
        endDate: filterByEndDate,
        filterByStatusId: filterByStatus,
        dptIds: filterByDeptId.length > 0 ? filterByDeptId : null,
        userIds: filterByUserIds.length > 0 ? filterByUserIds : null,
        locationIds: filterByLocationIds.length > 0 ? filterByLocationIds : null,
        timePeriod: filterByTimePeriod,
        filterByHideExpenseForUserManager: localFilterByHideFromManager == "1",
    })


    const deptOptions: Option[] = getAllDepByManager?.result?.map((dept: any) => ({
        value: dept.id,
        label: dept.value,
    }));
    const handleLocalFilterByHideFromManagerChange = (selectedOption: any) => {
        setLocalFilterByHideFromManager(selectedOption.value);
    };
    const handleDeptChange = (selected: Option[]) => {
        setSelectedDeptId(selected);
        setLocalFilterByDeptId(selected?.map((dept) => dept.value));
    };

    const locationOptions: Option[] = getAllUsersLocation?.result?.map((location: any) => ({
        value: location.id,
        label: location.value,
    }));

    const handleLocationChange = (selected: Option[]) => {
        setSelectedLocationIds(selected);
        setLocalFilterByLocationIds(selected?.map((location) => location.value));
    };

    const handleManagerChange = (selectedOption: any) => {
        setFilterByManager(selectedOption.value);
    };

    const userIdsOptions: Option[] = getUserByManager?.result?.map((userByManager: any) => ({
        value: userByManager.id,
        label: userByManager.value,
    }));

    const handleUserIdsChange = (selected: Option[]) => {
        setSelectedUserIds(selected);
        setLocalFilterByUserIds(selected?.map((userByManager) => userByManager.value));
    };
    const handleTimePeriodChange = (selectedOption: any) => {
        setLocalFilterByTimePeriod(selectedOption.value);
        setLocalFilterByStartDate('');
        setLocalFilterByEndDate('');
    };
    const handlePageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setPage(1); // Reset page number to 1
    };
    // pagination
    const handlePageClick = (e: any) => {
        setPage(e.selected + 1);
    };

    const handleSort = (property: string) => {
        setSortBy(property);
        if (sortedColumn === property) {
            setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
        } else {
            setSortedColumn(property);
            setSortOrder("asc");
        }
    };

    //per page record
    const handlePageRecords = (e: any) => {
        setPage(1); // Reset the page to 1
    };
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value); // Update immediate search state

        delayedSearch(value); // Update debounced search state
        setPage(1);
    };

    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );

    const handleDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        setLocalFilterByStartDate(startDateFormatted);
        setLocalFilterByEndDate(endDateFormatted);
        setLocalFilterByTimePeriod('')
    };
    const handleCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setFilterByStartDate("");
        setFilterByEndDate("");
        setLocalFilterByStartDate("");
        setLocalFilterByEndDate("");
    };

    const handleStatusChange = (e: any) => {
        setLocalFilterByStatus(e.value);
    };
    const handleFilterByExpType = (selectedOption: any) => {
        setLocalFilterByExpType(selectedOption.value);
    };

    const applyFilters = () => {
        setIsApplyingFilters(true);
        setFilterByStartDate(localFilterByStartDate);
        setFilterByEndDate(localFilterByEndDate);
        setFilterByStatus(localFilterByStatus);
        setFilterByExpType(localFilterByExpType);
        setFilterByDeptId(localFilterByDeptId);
        setFilterByLocationIds(localFilterByLocationIds);
        setFilterByUserIds(localFilterByUserIds);
        setFilterByTimePeriod(localFilterByTimePeriod);
        setPage(1);
    };
    const resetFilters = () => {
        setFilterByStartDate(sevenDaysAgo);
        setFilterByEndDate(currentDate);
        setFilterByExpType("0");
        setFilterByStatus('0');
        setFilterByDeptId([])
        setFilterByLocationIds([])
        setFilterByUserIds([])
        setFilterByManager(0)
        setFilterByTimePeriod('')

        setLocalFilterByStartDate(sevenDaysAgo);
        setLocalFilterByEndDate(currentDate);
        setLocalFilterByExpType("0");
        setLocalFilterByStatus('0');
        setLocalFilterByDeptId([])
        setLocalFilterByLocationIds([])
        setLocalFilterByUserIds([])
        setLocalFilterByTimePeriod('')

        setSelectedDeptId([])
        setSelectedLocationIds([])
        setSelectedUserIds([])

    }

    const debouncedRefetch = debounce(() => {
        refetch().finally(() => {
            setIsApplyingFilters(false);
        });
    }, 300);
    useEffect(() => {
        if (isApplyingFilters) {
            debouncedRefetch();
        }
    }, [isApplyingFilters]);

    useEffect(() => {
        if (
            searchStr === "" ||
            sortOrder === "" ||
            sortBy === "") {
            refetch();
        }
    }, [searchStr, sortOrder, sortBy]);

    const [showExpenseDetailModal, setShowExpenseDetailModal] = useState(false)
    const [expenseDetailData, setExpenseDetailData] = useState({});

    const expenseDetailHandler = () => {
        setShowExpenseDetailModal((prev) => !prev);
    };

    const handleRefresh = () => {
        // Set the state values
        // setFilterByStartDate(sevenDaysAgo);
        // setFilterByEndDate(currentDate);
        // setLocalFilterByStartDate(sevenDaysAgo);
        // setLocalFilterByEndDate(currentDate);

        // Trigger refetch after state updates are done
        setTimeout(() => {
            refetch()
                .then(() => {
                    if (isSuccess) {
                        toast.success(tosterKey.dataRefreshedSuccesfully);
                    }
                });
        }, 0);
    };
    return (
        <>
            <ExpenseDetailModal show={showExpenseDetailModal} handleClose={() => setShowExpenseDetailModal(false)} data={expenseDetailData} expenseItems={expenseItemData?.result} isFetching={isFetching} />

            <div className='card' style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                <div className='card-header border-0  align-items-center'>
                    <div className="col-12">
                        <Alert variant="primary" className="">
                            <p className='fs-6'>Displays all expense reports created by users along with their report details, approval status, assigned approvers, total amount, comments, and available actions. This page helps users track the complete lifecycle and current status of expense reports based on the selected filters.</p>
                        </Alert>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                        <SearchBarComponent
                            placeholder='Expense'
                            value={immediateSearchStr}
                            onChange={handleSearchChange}
                        />
                        <RefreshComponent onClick={handleRefresh} />
                    </div>
                    <button
                        type='button'
                        className='btn btn-sm btn-light-primary me-3 d-flex justify-content-end'
                        role='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#report_filters'
                        aria-expanded='true'
                        aria-controls='report_filters'
                    >
                        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                        {labelKey.filter}
                    </button>
                </div>
                <div className='card-body pb-5 pt-0'>
                    <div className="row collapse border-bottom" id='report_filters'>
                        <>
                            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <DateRangeComp
                                    startDate={localFilterByStartDate || moment().subtract(6, 'days')}
                                    endDate={localFilterByEndDate || moment()}
                                    onApply={handleDateRangeChange} onCancel={handleCancelDateSelection}
                                    value={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : "MM/DD/YYYY"} />
                            </div>
                            {/* <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <label className='form-label fs-6 fw-bold text-dark'>{labelKey.date}:</label>
                                    <div className='position-relative mb-2'>
                                        <label className='position-absolute text-primary'>Custom Date Range</label>
                                        <DateRangePicker onApply={handleDateRangeChange} onCancel={handleCancelDateSelection}>
                                            <input type="text"
                                                className='h-10px mw-100px opacity-0 cursor-pointer'
                                                value={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : "mm/dd/yyyy"} />
                                        </DateRangePicker>
                                    </div>
                                </div>
                                <Select
                                    // customLabelClick={() => setDateRangeHide(true)}
                                    options={[
                                        { value: 0, label: 'All' }, // Add the empty option
                                        ...(timePeriodOptions?.map((option: any) => ({
                                            value: option.id,
                                            label: option?.value,
                                        })))
                                    ]}
                                    placeholder={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : 'Select Date'}
                                    value={localFilterByTimePeriod && localFilterByTimePeriod !== ''
                                        ? {
                                            label: timePeriodOptions?.find((option: any) => option.id === localFilterByTimePeriod)?.value || '',
                                            value: localFilterByTimePeriod,
                                        }
                                        : null
                                    }
                                    onChange={handleTimePeriodChange}
                                />

                            </div> */}

                            {/* <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <label className='form-label fs-5 fw-bold'>{labelKey.expenseType}:</label>
                                <Select
                                    options={[
                                        // { value: '0', label: 'All' }, // Add the empty option
                                        ...(getAllExpenseType?.result || []).map((option: any) => ({
                                            value: option.id,
                                            label: option?.value,
                                        })),
                                    ]}
                                    placeholder={
                                        localFilterByExpType
                                            ? getAllExpenseType?.result.find((option: any) => option.id === localFilterByExpType)?.value
                                            : 'Select Type'
                                    }
                                    value={localFilterByExpType}
                                    onChange={handleFilterByExpType}
                                />
                            </div> */}
                            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <SearchSelect
                                    label={`${labelKey.statusFilter}:`}
                                    options={[
                                        // { value: '', label: '' }, // Add the empty option
                                        ...(Array.isArray(ExpenseStatusLookup?.result) ? ExpenseStatusLookup.result.map((option: any) => ({
                                            value: option.id,
                                            label: option?.value,
                                        })) : [])
                                    ]}
                                    placeholder={labelKey.selectStatus}
                                    value={localFilterByStatus && localFilterByStatus !== '0'
                                        ? {
                                            value: localFilterByStatus,
                                            label: ExpenseStatusLookup?.result.find((option: any) => option.id === localFilterByStatus)?.value,
                                        }
                                        : null
                                    }
                                    onChange={handleStatusChange}
                                />
                            </div>
                            <div className='col-md-4 col-lg-2 col-xl-2 mb-5'>
                                <SearchSelect
                                    label={`${labelKey.filterByHideExpenseForUserManager}:`}
                                    options={[
                                        {
                                            value: "1",
                                            label: "Yes",
                                        }, {
                                            value: "0",
                                            label: "No",
                                        }]}
                                    placeholder={labelKey.filterByHideExpenseForUserManager}
                                    value={localFilterByHideFromManager && localFilterByHideFromManager !== '0'
                                        ? {
                                            value: localFilterByHideFromManager,
                                            label: "Yes"
                                        }
                                        : {
                                            value: localFilterByHideFromManager,
                                            label: "No"
                                        }
                                    }

                                    onChange={handleLocalFilterByHideFromManagerChange}
                                />
                            </div>
                            {!myReportPath &&
                                <>
                                    {(roleID === constraintConfig.roleID.role4 && queryFeportPath) ||
                                        (roleID === constraintConfig.roleID.role10 && queryFeportPath) ||
                                        (roleID === constraintConfig.roleID.role2 && queryFeportPath) ? (
                                        <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                            <SearchSelect
                                                label={`${labelKey.manager}:`}
                                                options={[
                                                    // { value: 0, label: 'All' }, // Add the empty option
                                                    ...(Array.isArray(getAllManagers?.result) ? getAllManagers.result.map((option: any) => ({
                                                        value: option.id,
                                                        label: option?.value,
                                                    })) : [])
                                                ]}
                                                placeholder='Select Manager...'
                                                value={filterByManager && filterByManager !== 0
                                                    ? {
                                                        value: filterByManager,
                                                        label: getAllManagers?.result.find((option: any) => option.id === filterByManager)?.value
                                                    }
                                                    : null
                                                }
                                                onChange={handleManagerChange}
                                            />
                                        </div>
                                    ) : null}
                                    <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                        <label className='form-label fs-6 fw-bold'>{labelKey.users}:</label>
                                        <Select
                                            isMulti
                                            options={userIdsOptions}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{ Option: CheckboxOption }}
                                            onChange={(selected) => handleUserIdsChange(selected as Option[])} // Casting to Option[]
                                            value={selectedUserIds} // Directly use selectedDeptId as it is of type Option[]
                                            placeholder='Search User...'
                                            className='filter-valueContainer'
                                        />
                                    </div>
                                    <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                        <label className='form-label fs-6 fw-bold'>{labelKey.department}:</label>
                                        <Select
                                            isMulti
                                            options={deptOptions}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{ Option: CheckboxOption }}
                                            onChange={(selected) => handleDeptChange(selected as Option[])} // Casting to Option[]
                                            value={selectedDeptId} // Directly use selectedDeptId as it is of type Option[]
                                            placeholder='Search Dept...'
                                            className='filter-valueContainer'
                                        />
                                    </div>
                                    <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                        <label className='form-label fs-6 fw-bold'>{labelKey.location}:</label>
                                        <Select
                                            isMulti
                                            options={locationOptions}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{ Option: CheckboxOption }}
                                            onChange={(selected) => handleLocationChange(selected as Option[])} // Casting to Option[]
                                            value={selectedLocationIds} // Directly use selectedDeptId as it is of type Option[]
                                            placeholder='Search Location...'
                                            className='filter-valueContainer'
                                        />
                                    </div>
                                </>
                            }

                            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <div className='d-flex align-items-end h-100 gap-3'>
                                    <button className='btn btn-danger pull-right me-3' onClick={resetFilters}>Reset Filters</button>

                                    <button className='btn btn-primary pull-right' onClick={applyFilters}>
                                        {isApplyingFilters ? <>
                                            <span>loading...</span>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        </> : "Apply Filters"}
                                    </button>
                                </div>
                            </div>
                        </>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='table-responsive table-height'>
                                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                    <thead>
                                        <tr className='fw-bold text-muted'>
                                            {hiddenColumns.includes('reportId') && (
                                                <TableHeading
                                                    label={labelKey.reportId}
                                                    columnId='reportId'
                                                    className="ps-4"
                                                />
                                            )}
                                            {/* {hiddenColumns.includes('expenseType') && (
                                                <TableHeading
                                                    label={labelKey.type}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='expenseType'
                                                />
                                            )} */}
                                            {hiddenColumns.includes('title') && (
                                                <TableHeading
                                                    label={labelKey.title}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='title'
                                                />
                                            )}
                                            {hiddenColumns.includes('expenseDetail') && (
                                                <TableHeading
                                                    label={labelKey.expenseDetail}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='expenseDetail'
                                                />
                                            )}
                                            {hiddenColumns.includes('amount') && (
                                                <TableHeading
                                                    label={labelKey.totalAmount}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='amount'
                                                />
                                            )}
                                            {hiddenColumns.includes('createdDate') && (
                                                <TableHeading
                                                    label={labelKey.date}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='createdDate'
                                                />
                                            )}
                                            {hiddenColumns.includes('expenseStatus') && (
                                                <TableHeading
                                                    label={labelKey.status}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='expenseStatus'
                                                />
                                            )}
                                            {hiddenColumns.includes('manager') && (
                                                <TableHeading
                                                    label={labelKey.assignTo}
                                                    sortedColumn={sortedColumn}
                                                    sortOrder={sortOrder}
                                                    handleSort={handleSort}
                                                    columnId='manager'
                                                />
                                            )}
                                            {hiddenColumns.includes('comment') && (
                                                <TableHeading
                                                    label={labelKey.comment}
                                                    columnId='comment'
                                                />
                                            )}
                                            <th className='text-end rounded-end pe-2 border-0'>
                                                {hiddenColumns.includes('actions') && (
                                                    <>
                                                        {labelKey.actions}
                                                    </>
                                                )}
                                                <TableSettingMenu>
                                                    <TextField
                                                        rightLabel={labelKey.reportId}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("reportId")}
                                                        checked={hiddenColumns.includes('reportId')}
                                                        fieldClass='mb-4'
                                                    />

                                                    {/* <TextField
                                                        rightLabel={labelKey.type}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("expenseType")}
                                                        checked={hiddenColumns.includes('expenseType')}
                                                        fieldClass='mb-4'
                                                    /> */}
                                                    <TextField
                                                        rightLabel={labelKey.title}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("title")}
                                                        checked={hiddenColumns.includes('title')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.totalAmount}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("amount")}
                                                        checked={hiddenColumns.includes('amount')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.date}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("createdDate")}
                                                        checked={hiddenColumns.includes('createdDate')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.status}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("expenseStatus")}
                                                        checked={hiddenColumns.includes('expenseStatus')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.assignTo}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("manager")}
                                                        checked={hiddenColumns.includes('manager')}
                                                        fieldClass='mb-4'
                                                    />

                                                    <TextField
                                                        rightLabel={labelKey.comment}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("comment")}
                                                        checked={hiddenColumns.includes('comment')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.actions}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("actions")}
                                                        checked={hiddenColumns.includes('actions')}
                                                        fieldClass='mb-4'
                                                    />
                                                </TableSettingMenu>
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!isLoading &&
                                            <>
                                                {data?.result?.data?.length > 0 ? (
                                                    <>
                                                        {data?.result?.data?.map((data: any, index: any) => (
                                                            <tr key={index}>
                                                                {/* <td className='ps-5'>{(page - 1) * pageSize + index + 1}</td> */}
                                                                {hiddenColumns.includes('reportId') && (
                                                                    <td className='ps-5'>{data?.trackingId}</td>
                                                                )}
                                                                {/* {hiddenColumns.includes('expenseType') && (
                                                                    <td>{data?.expenseType?.title}</td>
                                                                )} */}
                                                                {hiddenColumns.includes('title') && (
                                                                    <td>{data?.title}</td>
                                                                )}
                                                                {hiddenColumns.includes('expenseDetail') && (
                                                                    <td>{data?.expenseDetail?.length > 60 ? `${data?.expenseDetail.substring(0, 40)}...` : data?.expenseDetail}</td>
                                                                )}
                                                                {hiddenColumns.includes('amount') && (
                                                                    <td><CurrencyComp amount={data?.amount} /></td>
                                                                )}
                                                                {hiddenColumns.includes('createdDate') && (
                                                                    <td><DateComp formattedDate={data.reportDate} /></td>
                                                                )}
                                                                {hiddenColumns.includes('expenseStatus') && (
                                                                    <td>
                                                                        <ExpenseStatusComp expenseStatusId={data?.expenseStatus?.id} expenseStatusTitle={data?.expenseStatus?.title} />
                                                                    </td>
                                                                )}
                                                                {hiddenColumns.includes('manager') && (
                                                                    <td>
                                                                        {data?.manager?.firstName && <>
                                                                            {data?.expenseStatus?.title === "Pending for Approval" ? (
                                                                                <div className='d-flex align-items-center'>
                                                                                    <div className='symbol symbol-40px symbol-circle me-3'>
                                                                                        {data?.manager?.imageUrl ? <img src={data?.manager?.imageUrl} alt="" /> :
                                                                                            <div className="symbol-label fs-3 bg-light-info text-info text-capitalize">{data?.manager?.firstName?.charAt(0)}</div>
                                                                                        }
                                                                                    </div>
                                                                                    <div className='d-flex justify-content-start flex-column'>
                                                                                        <p className='text-capitalize mb-0'>
                                                                                            {data?.manager?.firstName}  {data?.manager?.middleName} {data?.manager?.lastName}
                                                                                        </p>
                                                                                        <span className='text-muted fw-semibold text-muted d-block fs-7 text-lowercase'>
                                                                                            {data?.manager?.email}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            ) : "Not Assigned"}
                                                                        </>}
                                                                    </td>
                                                                )}
                                                                {hiddenColumns.includes('comment') && (
                                                                    <td>{data?.comment && data?.comment.length > 20 ? `${data?.comment.substring(0, 20)}...` : data?.comment}</td>
                                                                )}
                                                                {hiddenColumns.includes('actions') && (
                                                                    <td className='text-end' >
                                                                        <div className='d-flex align-items-center justify-content-end gap-2' >
                                                                            {/* <OverlayTrigger
                                                                                delay={{ show: 250, hide: 350 }}
                                                                                overlay={
                                                                                    <Tooltip>
                                                                                        {labelKey.report}
                                                                                    </Tooltip>
                                                                                }>
                                                                                <Link to={`/report/${data?.expenseId}`}>
                                                                                    <div className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                                                                                        <FaFile />
                                                                                    </div>
                                                                                </Link>
                                                                            </OverlayTrigger> */}
                                                                            {/* <Tooltip id="report-download" />
                                                                            <div
                                                                                data-tooltip-id="report-download" data-tooltip-content='Report Download'
                                                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                                                onClick={() => {
                                                                                    handleDownloadPdf(data);
                                                                                }}  >
                                                                                {!isLoadingPdf[data.expenseId] ?
                                                                                    <FaDownload className='text-dark text-hover-primary' />
                                                                                    :
                                                                                    <div className="spinner-border spinner-border-sm" role="status">
                                                                                        <span className="sr-only">{labelKey.loading}...</span>
                                                                                    </div>
                                                                                }

                                                                            </div> */}
                                                                            <DownloadReport data={data} />
                                                                            <div
                                                                                data-tooltip-id={labelKey.updateExpense} data-tooltip-content={labelKey.updateExpense}
                                                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                                                onClick={() => {
                                                                                    expenseItemByIdTrigger({ ExpenseId: data?.expenseId });
                                                                                    setExpenseDetailData(data);
                                                                                    expenseDetailHandler();
                                                                                }}
                                                                            >
                                                                                <KTSVG
                                                                                    path='/media/icons/duotune/arrows/arr064.svg'
                                                                                    className='svg-icon-3'
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        ))}
                                                    </>
                                                ) :
                                                    (
                                                        <tr>
                                                            <td colSpan={10}>
                                                                <NoRecordFound />
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </>
                                        }
                                        {isLoading && (
                                            <tr>
                                                <td colSpan={10} className="text-center">
                                                    <LoadingComponent />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <Pagination
                            totalResult={data?.result?.totalRecords === 0 ? 0 : ((data?.result?.pageNumber - 1) * data?.result?.pageSize) + 1}
                            toResult={data?.result?.totalRecords === 0 ? 0 : Math.min(data?.result?.pageNumber * data?.result?.pageSize, data?.result?.totalRecords)}
                            ofResult={data?.result?.totalRecords}
                            onChange={handlePageSizeChange}
                            pageSize={pageSize}
                            onPageChange={handlePageClick}
                            pageCount={data?.result?.totalPages || 0}
                            currentPage={page}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExpenseDetail